// Converts fixed ISO seed dates into the compact timeline timestamp contract.
const read_seed_time = (value) => {
    return Date.parse(value);
};

const accountAutomation = {
    id: "accounts-automation",
    label: "Accounts automation"
};

const paymentAutomation = {
    id: "payments-automation",
    label: "Payments automation"
};

const mariaSeller = {
    id: "seller-maria",
    label: "Maria Papadopoulou",
    aliases: ["maria.papadopoulou@doitforme.eu", "maria.p"]
};

const andreasSeller = {
    id: "seller-andreas",
    label: "Andreas Nikolaou",
    aliases: ["andreas.nikolaou@doitforme.eu", "andreas.n"]
};

const eleniCaller = {
    id: "caller-eleni",
    label: "Eleni Georgiou",
    aliases: ["eleni.georgiou@doitforme.eu", "eleni.g"]
};

const tasksOwner = {
    id: "tasks-sofia",
    label: "Sofia Konstantinou",
    aliases: ["sofia.konstantinou@doitforme.eu", "sofia.k"]
};

// Provides one deterministic Brand story in the same compact v3 shape as production.
export const timelineSeed = [
    {
        id: "brand-created",
        type: "BRAND_CREATED",
        app: "niffler",
        at: read_seed_time("2026-01-05T08:00:00.000Z"),
        seq: read_seed_time("2026-01-05T08:00:01.000Z"),
        actor: mariaSeller
    },
    {
        id: "owner-registered",
        type: "OWNER_REGISTERED",
        app: "erised",
        at: read_seed_time("2026-01-05T08:15:00.000Z"),
        seq: read_seed_time("2026-01-05T08:15:01.000Z"),
        actor: accountAutomation
    },
    {
        id: "account-business-update",
        type: "BRAND_UPDATE",
        app: "erised",
        at: read_seed_time("2026-01-05T08:30:00.000Z"),
        seq: read_seed_time("2026-01-05T08:30:01.000Z"),
        actor: accountAutomation,
        group: "account-onboarding",
        changes: [
            ["Brand", null, "TYMELY"],
            ["Category", null, "Professional Services"],
            ["Subcategory", null, "Marketing"],
            ["Location", null, "Athens, Greece"]
        ]
    },
    {
        id: "questad-paid-activated",
        type: "TAG",
        app: "erised",
        at: read_seed_time("2026-01-05T08:29:40.000Z"),
        seq: read_seed_time("2026-01-05T08:30:02.000Z"),
        actor: paymentAutomation,
        group: "account-onboarding",
        changes: [["Paid Questad", "Inactive", "Active"]]
    },
    {
        id: "seller-assigned",
        type: "SELLER_ASSIGNED",
        app: "niffler",
        at: read_seed_time("2026-01-06T09:00:00.000Z"),
        seq: read_seed_time("2026-01-06T09:00:01.000Z"),
        actor: andreasSeller,
        changes: [["Seller", null, "Maria Papadopoulou"]]
    },
    {
        id: "moved-to-call",
        type: "TO_CALL",
        app: "niffler",
        at: read_seed_time("2026-01-06T09:10:00.000Z"),
        seq: read_seed_time("2026-01-06T09:10:01.000Z"),
        actor: mariaSeller,
        changes: [["Status", "Backlog", "To Call"]]
    },
    {
        id: "html-comment",
        type: "COMMENT",
        app: "niffler",
        at: read_seed_time("2026-01-06T09:20:00.000Z"),
        seq: read_seed_time("2026-01-06T09:20:01.000Z"),
        actor: mariaSeller,
        text: "&lt;p&gt;The owner asked me to call again after the morning meeting.&lt;/p&gt;"
    },
    {
        id: "duplicate-html-comment",
        type: "COMMENT",
        app: "cerebro",
        at: read_seed_time("2026-01-06T09:21:00.000Z"),
        seq: read_seed_time("2026-01-06T09:21:01.000Z"),
        actor: tasksOwner,
        text: " the owner asked me to call again after the morning meeting. "
    },
    {
        id: "work-started-group",
        type: "IN_PROGRESS",
        app: "niffler",
        at: read_seed_time("2026-01-07T10:00:00.000Z"),
        seq: read_seed_time("2026-01-07T10:00:01.000Z"),
        actor: mariaSeller,
        group: "sales-discovery",
        changes: [["Status", "To Call", "In Progress"]]
    },
    {
        id: "discovery-update-group",
        type: "BRAND_UPDATE",
        app: "niffler",
        at: read_seed_time("2026-01-07T09:59:42.000Z"),
        seq: read_seed_time("2026-01-07T10:00:02.000Z"),
        actor: mariaSeller,
        group: "sales-discovery",
        changes: [
            ["Phone", null, "+30 210 123 4567"],
            ["Email", "hello@tymely.example", "vasilis@tymely.example"],
            ["Username", "tymely_old", "tymely"]
        ]
    },
    {
        id: "discovery-comment-group",
        type: "COMMENT",
        app: "niffler",
        at: read_seed_time("2026-01-07T09:59:25.000Z"),
        seq: read_seed_time("2026-01-07T10:00:03.000Z"),
        actor: mariaSeller,
        group: "sales-discovery",
        text: "Spoke with Vasilis.\nHe manages the business and wants the proposal sent by email."
    },
    {
        id: "stalling-callback",
        type: "STALLING",
        app: "niffler",
        at: read_seed_time("2026-01-07T10:30:00.000Z"),
        seq: read_seed_time("2026-01-07T10:30:01.000Z"),
        actor: mariaSeller,
        text: "Waiting for the co-owner to return from a business trip.",
        changes: [["Status", "In Progress", "Stalling"]],
        detail: {
            schedule: read_seed_time("2026-01-12T09:30:00.000Z")
        }
    },
    {
        id: "sales-session-agency",
        type: "SALES_SESSION",
        app: "niffler",
        at: read_seed_time("2026-01-12T11:30:00.000Z"),
        seq: read_seed_time("2026-01-12T11:30:01.000Z"),
        actor: mariaSeller,
        detail: {
            openedAt: read_seed_time("2026-01-12T09:20:00.000Z"),
            closedAt: read_seed_time("2026-01-12T11:30:00.000Z"),
            outcome: "Agency",
            periods: [
                ["to_call", read_seed_time("2026-01-12T09:20:00.000Z"), read_seed_time("2026-01-12T09:35:00.000Z")],
                ["in_progress", read_seed_time("2026-01-12T09:35:00.000Z"), read_seed_time("2026-01-12T10:20:00.000Z")],
                ["stalling", read_seed_time("2026-01-12T10:20:00.000Z"), read_seed_time("2026-01-12T11:00:00.000Z")],
                ["in_progress", read_seed_time("2026-01-12T11:00:00.000Z"), read_seed_time("2026-01-12T11:30:00.000Z")]
            ],
            events: [
                {
                    id: "sales-session-started",
                    type: "IN_PROGRESS",
                    at: read_seed_time("2026-01-12T09:35:00.000Z"),
                    actor: mariaSeller,
                    text: "In Progress"
                },
                {
                    id: "sales-session-comment",
                    type: "COMMENT",
                    at: read_seed_time("2026-01-12T09:50:00.000Z"),
                    actor: mariaSeller,
                    text: "The owner confirmed the annual package and requested an Agency offer."
                },
                {
                    id: "sales-session-field-update",
                    type: "BRAND_UPDATE",
                    at: read_seed_time("2026-01-12T10:05:00.000Z"),
                    actor: mariaSeller,
                    changes: [
                        ["VAT", null, "EL123456789"],
                        ["Location", "Athens, Greece", "Kifisia, Greece"]
                    ]
                },
                {
                    id: "sales-session-callback",
                    type: "STALLING",
                    at: read_seed_time("2026-01-12T10:20:00.000Z"),
                    actor: mariaSeller,
                    text: "Waiting for final approval.",
                    detail: {
                        schedule: read_seed_time("2026-01-12T11:00:00.000Z")
                    }
                },
                {
                    id: "sales-session-exit",
                    type: "SALES_EXIT",
                    at: read_seed_time("2026-01-12T11:30:00.000Z"),
                    actor: mariaSeller,
                    text: "Agency"
                }
            ]
        }
    },
    {
        id: "offer-created",
        type: "OFFER_CREATED",
        app: "godfather",
        at: read_seed_time("2026-01-12T11:30:20.000Z"),
        seq: read_seed_time("2026-01-12T11:30:21.000Z"),
        actor: mariaSeller,
        group: "agency-offer-2026",
        detail: {
            ref: "OFR-2026-00184"
        }
    },
    {
        id: "offer-paid",
        type: "OFFER_PAID",
        app: "godfather",
        at: read_seed_time("2026-01-20T13:00:00.000Z"),
        seq: read_seed_time("2026-01-20T13:00:01.000Z"),
        actor: andreasSeller,
        group: "offer-payment-client",
        detail: {
            ref: "OFR-2026-00184",
            paymentKind: "recurring",
            paymentSource: "stripe",
            subscriptionId: "sub_2026_00184",
            services: ["Meta Ads", "Google Ads", "Social Media Management"]
        }
    },
    {
        id: "offer-stopped",
        type: "OFFER_STOPPED",
        app: "godfather",
        at: read_seed_time("2026-04-20T13:00:00.000Z"),
        seq: read_seed_time("2026-04-20T13:00:01.000Z"),
        actor: andreasSeller,
        group: "offer-payment-client",
        detail: {
            ref: "OFR-2026-00184",
            subscriptionId: "sub_2026_00184",
            status: "canceled"
        }
    },
    {
        id: "client-created",
        type: "CLIENT_CREATED",
        app: "cerebro",
        at: read_seed_time("2026-01-20T12:59:40.000Z"),
        seq: read_seed_time("2026-01-20T13:00:03.000Z"),
        actor: tasksOwner,
        group: "offer-payment-client",
        detail: {
            dif: "DIF-10482"
        }
    },
    {
        id: "client-linked",
        type: "CLIENT_LINKED",
        app: "cerebro",
        at: read_seed_time("2026-01-20T12:59:20.000Z"),
        seq: read_seed_time("2026-01-20T13:00:04.000Z"),
        actor: tasksOwner,
        group: "offer-payment-client",
        detail: {
            dif: "DIF-10482"
        }
    },
    {
        id: "client-communication",
        type: "COMMUNICATION",
        app: "cerebro",
        at: read_seed_time("2026-03-03T14:00:00.000Z"),
        seq: read_seed_time("2026-03-03T14:00:01.000Z"),
        actor: tasksOwner,
        detail: {
            code: "COMM-731",
            title: "Facebook access required",
            description: "<p>The client could not grant Page access and asked for step-by-step assistance.</p>",
            comments: [
                {
                    id: "communication-comment-1",
                    text: "&lt;p&gt;I sent the access guide and offered a screen-sharing call.&lt;/p&gt;",
                    actor: tasksOwner,
                    at: read_seed_time("2026-03-03T12:30:00.000Z")
                },
                {
                    id: "communication-comment-2",
                    text: "Access was granted successfully. The issue can be closed.",
                    actor: {
                        id: "client-vasilis",
                        label: "Vasilis Fotou",
                        aliases: ["vasilis@tymely.example"]
                    },
                    at: read_seed_time("2026-03-03T13:55:00.000Z")
                },
                {
                    id: "communication-comment-duplicate",
                    text: "spoke with vasilis. he manages the business and wants the proposal sent by email.",
                    actor: tasksOwner,
                    at: read_seed_time("2026-03-03T13:56:00.000Z")
                }
            ]
        }
    },
    {
        id: "client-unlinked",
        type: "CLIENT_UNLINKED",
        app: "cerebro",
        at: read_seed_time("2026-03-10T09:00:00.000Z"),
        seq: read_seed_time("2026-03-10T09:00:01.000Z"),
        actor: tasksOwner,
        detail: {
            dif: "DIF-10482"
        }
    },
    {
        id: "client-relinked",
        type: "CLIENT_LINKED",
        app: "cerebro",
        at: read_seed_time("2026-03-10T09:30:00.000Z"),
        seq: read_seed_time("2026-03-10T09:30:01.000Z"),
        actor: tasksOwner,
        detail: {
            dif: "DIF-10482"
        }
    },
    {
        id: "sales-session-sass",
        type: "SALES_SESSION",
        app: "niffler",
        at: read_seed_time("2026-04-01T10:00:00.000Z"),
        seq: read_seed_time("2026-04-01T10:00:01.000Z"),
        actor: mariaSeller,
        detail: {
            openedAt: read_seed_time("2026-04-01T08:30:00.000Z"),
            closedAt: read_seed_time("2026-04-01T10:00:00.000Z"),
            outcome: "SASS",
            periods: [
                ["to_call", read_seed_time("2026-04-01T08:30:00.000Z"), read_seed_time("2026-04-01T08:45:00.000Z")],
                ["in_progress", read_seed_time("2026-04-01T08:45:00.000Z"), read_seed_time("2026-04-01T10:00:00.000Z")]
            ],
            events: [
                {
                    id: "sales-sass-comment",
                    type: "COMMENT",
                    at: read_seed_time("2026-04-01T09:10:00.000Z"),
                    actor: mariaSeller,
                    text: "The client wants to discuss the SASS package with a specialist."
                },
                {
                    id: "sales-sass-handoff",
                    type: "SASS",
                    at: read_seed_time("2026-04-01T10:00:00.000Z"),
                    actor: mariaSeller,
                    text: "SASS meeting 2026-04-02T08:00:00.000Z",
                    detail: {
                        schedule: read_seed_time("2026-04-02T08:00:00.000Z")
                    }
                }
            ]
        }
    },
    {
        id: "sass-handoff-lost-cycle",
        type: "SASS",
        app: "niffler",
        at: read_seed_time("2026-04-01T10:00:20.000Z"),
        seq: read_seed_time("2026-04-01T10:00:21.000Z"),
        actor: mariaSeller,
        text: "The owner requested an afternoon call if the first slot is missed.",
        detail: {
            previousStatus: "In Progress",
            schedule: read_seed_time("2026-04-02T08:00:00.000Z"),
            registrationId: "SASS-REG-440"
        }
    },
    {
        id: "sass-set-lost-cycle",
        type: "SASS_SET",
        app: "godfather",
        at: read_seed_time("2026-04-02T07:30:00.000Z"),
        seq: read_seed_time("2026-04-02T07:30:01.000Z"),
        actor: eleniCaller,
        text: "The client confirmed the scheduled time.",
        detail: {
            schedule: read_seed_time("2026-04-02T08:00:00.000Z")
        }
    },
    {
        id: "sass-rescheduled-lost-cycle",
        type: "SASS_RESCHEDULE",
        app: "godfather",
        at: read_seed_time("2026-04-02T07:50:00.000Z"),
        seq: read_seed_time("2026-04-02T07:50:01.000Z"),
        actor: eleniCaller,
        text: "The owner was delayed at another meeting.",
        detail: {
            schedule: read_seed_time("2026-04-02T12:30:00.000Z")
        }
    },
    {
        id: "sass-in-progress-lost-cycle",
        type: "SASS_IN_PROGRESS",
        app: "godfather",
        at: read_seed_time("2026-04-02T12:30:00.000Z"),
        seq: read_seed_time("2026-04-02T12:30:01.000Z"),
        actor: eleniCaller,
        detail: {
            registrationId: "SASS-REG-440"
        }
    },
    {
        id: "sass-lost-standalone",
        type: "SASS_LOST",
        app: "godfather",
        at: read_seed_time("2026-04-02T13:00:00.000Z"),
        seq: read_seed_time("2026-04-02T13:00:01.000Z"),
        actor: eleniCaller,
        detail: {
            registrationId: "SASS-REG-440"
        }
    },
    {
        id: "sass-session-lost",
        type: "SASS_SESSION",
        app: "godfather",
        at: read_seed_time("2026-04-03T21:01:00.000Z"),
        seq: read_seed_time("2026-04-03T21:01:01.000Z"),
        actor: eleniCaller,
        detail: {
            openedAt: read_seed_time("2026-04-01T10:00:20.000Z"),
            closedAt: read_seed_time("2026-04-03T21:01:00.000Z"),
            outcome: "Lost",
            periods: [
                ["set", read_seed_time("2026-04-01T10:00:20.000Z"), read_seed_time("2026-04-02T12:30:00.000Z")],
                ["in_progress", read_seed_time("2026-04-02T12:30:00.000Z"), read_seed_time("2026-04-02T13:00:00.000Z")],
                ["lost", read_seed_time("2026-04-02T13:00:00.000Z"), read_seed_time("2026-04-03T21:01:00.000Z")]
            ],
            events: [
                {
                    id: "sass-lost-comment",
                    type: "COMMENT",
                    at: read_seed_time("2026-04-02T12:40:00.000Z"),
                    actor: eleniCaller,
                    text: "<p>The owner decided to postpone the project until the next quarter.</p>"
                },
                {
                    id: "sass-lost-caller-change",
                    type: "SELLER_ASSIGNED",
                    at: read_seed_time("2026-04-02T12:45:00.000Z"),
                    actor: eleniCaller,
                    changes: [["Caller", "Andreas Nikolaou", "Eleni Georgiou"]]
                },
                {
                    id: "sass-lost-status",
                    type: "SASS_LOST",
                    at: read_seed_time("2026-04-02T13:00:00.000Z"),
                    actor: eleniCaller,
                    text: "SASS marked Lost"
                }
            ]
        }
    },
    {
        id: "questad-paid-deactivated",
        type: "TAG",
        app: "erised",
        at: read_seed_time("2026-04-04T08:00:00.000Z"),
        seq: read_seed_time("2026-04-04T08:00:01.000Z"),
        actor: paymentAutomation,
        changes: [["Paid Questad", "Active", "Inactive"]]
    },
    {
        id: "questad-lost-activated",
        type: "TAG",
        app: "erised",
        at: read_seed_time("2026-04-04T08:00:30.000Z"),
        seq: read_seed_time("2026-04-04T08:00:31.000Z"),
        actor: paymentAutomation,
        changes: [["Lost Questad", "Inactive", "Active"]]
    },
    {
        id: "sass-handoff-paid-cycle",
        type: "SASS",
        app: "niffler",
        at: read_seed_time("2026-05-04T08:00:00.000Z"),
        seq: read_seed_time("2026-05-04T08:00:01.000Z"),
        actor: mariaSeller,
        detail: {
            previousStatus: "To Call",
            schedule: read_seed_time("2026-05-05T09:00:00.000Z"),
            registrationId: "SASS-REG-512"
        }
    },
    {
        id: "sass-set-paid-cycle",
        type: "SASS_SET",
        app: "godfather",
        at: read_seed_time("2026-05-04T08:05:00.000Z"),
        seq: read_seed_time("2026-05-04T08:05:01.000Z"),
        actor: eleniCaller,
        detail: {
            schedule: read_seed_time("2026-05-05T09:00:00.000Z")
        }
    },
    {
        id: "sass-in-progress-paid-cycle",
        type: "SASS_IN_PROGRESS",
        app: "godfather",
        at: read_seed_time("2026-05-05T09:00:00.000Z"),
        seq: read_seed_time("2026-05-05T09:00:01.000Z"),
        actor: eleniCaller,
        detail: {
            registrationId: "SASS-REG-512"
        }
    },
    {
        id: "sass-paid-standalone",
        type: "SASS_PAID",
        app: "godfather",
        at: read_seed_time("2026-05-05T10:15:00.000Z"),
        seq: read_seed_time("2026-05-05T10:15:01.000Z"),
        actor: eleniCaller,
        detail: {
            registrationId: "SASS-REG-512"
        }
    },
    {
        id: "sass-session-paid",
        type: "SASS_SESSION",
        app: "godfather",
        at: read_seed_time("2026-05-05T10:20:00.000Z"),
        seq: read_seed_time("2026-05-05T10:20:01.000Z"),
        actor: eleniCaller,
        detail: {
            openedAt: read_seed_time("2026-05-04T08:00:00.000Z"),
            closedAt: read_seed_time("2026-05-05T10:20:00.000Z"),
            outcome: "Paid",
            periods: [
                ["set", read_seed_time("2026-05-04T08:00:00.000Z"), read_seed_time("2026-05-05T09:00:00.000Z")],
                ["in_progress", read_seed_time("2026-05-05T09:00:00.000Z"), read_seed_time("2026-05-05T10:00:00.000Z")],
                ["set", read_seed_time("2026-05-05T10:00:00.000Z"), read_seed_time("2026-05-05T10:10:00.000Z")],
                ["paid", read_seed_time("2026-05-05T10:10:00.000Z"), read_seed_time("2026-05-05T10:20:00.000Z")]
            ],
            events: [
                {
                    id: "sass-paid-comment",
                    type: "COMMENT",
                    at: read_seed_time("2026-05-05T09:20:00.000Z"),
                    actor: eleniCaller,
                    text: "The client selected the annual SASS package and supplied the billing information."
                },
                {
                    id: "sass-paid-account-update",
                    type: "BRAND_UPDATE",
                    at: read_seed_time("2026-05-05T09:35:00.000Z"),
                    actor: eleniCaller,
                    changes: [
                        ["Phone", "+30 210 123 4567", "+30 693 466 7137"],
                        ["Secondary email", "billing@tymely.example", null]
                    ]
                },
                {
                    id: "sass-paid-reschedule",
                    type: "SASS_RESCHEDULE",
                    at: read_seed_time("2026-05-05T10:00:00.000Z"),
                    actor: eleniCaller,
                    text: "The payment call moved by ten minutes.",
                    detail: {
                        schedule: read_seed_time("2026-05-05T10:10:00.000Z")
                    }
                },
                {
                    id: "sass-paid-status",
                    type: "SASS_PAID",
                    at: read_seed_time("2026-05-05T10:10:00.000Z"),
                    actor: eleniCaller,
                    text: "SASS payment confirmed"
                }
            ]
        }
    },
    {
        id: "questad-lost-deactivated",
        type: "TAG",
        app: "erised",
        at: read_seed_time("2026-05-05T10:21:00.000Z"),
        seq: read_seed_time("2026-05-05T10:21:01.000Z"),
        actor: paymentAutomation,
        group: "sass-paid-tags",
        changes: [["Lost Questad", "Active", "Inactive"]]
    },
    {
        id: "questad-paid-reactivated",
        type: "TAG",
        app: "erised",
        at: read_seed_time("2026-05-05T10:20:40.000Z"),
        seq: read_seed_time("2026-05-05T10:21:02.000Z"),
        actor: paymentAutomation,
        group: "sass-paid-tags",
        changes: [["Paid Questad", "Inactive", "Active"]]
    },
    {
        id: "tasks-brand-update",
        type: "BRAND_UPDATE",
        app: "cerebro",
        at: read_seed_time("2026-05-12T12:00:00.000Z"),
        seq: read_seed_time("2026-05-12T12:00:01.000Z"),
        actor: tasksOwner,
        changes: [
            ["Brand", "TYMELY", "TYMELY Growth Studio"],
            ["Description", null, "A long shared description proving that field values wrap cleanly without expanding the timeline into separate Previous and Current columns."],
            ["Secondary email", "support@tymely.example", null]
        ]
    },
    {
        id: "sync-warning",
        type: "SYNC_WARNING",
        app: "niffler",
        at: read_seed_time("2026-05-12T12:00:20.000Z"),
        seq: read_seed_time("2026-05-12T12:00:21.000Z"),
        text: "Tasks did not accept the latest shared field update. A retry is pending."
    },
    {
        id: "sync-recovered",
        type: "SYNC_RECOVERED",
        app: "niffler",
        at: read_seed_time("2026-05-12T12:10:00.000Z"),
        seq: read_seed_time("2026-05-12T12:10:01.000Z"),
        text: "Tasks accepted the pending shared field update."
    },
    {
        id: "seller-removed",
        type: "SELLER_REMOVED",
        app: "niffler",
        at: read_seed_time("2026-05-20T09:00:00.000Z"),
        seq: read_seed_time("2026-05-20T09:00:01.000Z"),
        actor: andreasSeller,
        changes: [["Seller", "Maria Papadopoulou", null]]
    },
    {
        id: "brand-lost",
        type: "LOST",
        app: "niffler",
        at: read_seed_time("2026-05-20T09:05:00.000Z"),
        seq: read_seed_time("2026-05-20T09:05:01.000Z"),
        actor: andreasSeller,
        text: "The client paused all additional services for budget reasons.",
        changes: [["Status", "In Progress", "Lost"]]
    },
    {
        id: "prospect-merged",
        type: "PROSPECT_MERGED",
        app: "niffler",
        at: read_seed_time("2026-06-01T08:00:00.000Z"),
        seq: read_seed_time("2026-06-01T08:00:01.000Z"),
        actor: andreasSeller,
        changes: [["Prospect", "Vasilis Fotou duplicate", "Vasilis Fotou"]]
    },
    {
        id: "brand-merged",
        type: "BRAND_MERGED",
        app: "niffler",
        at: read_seed_time("2026-06-01T08:30:00.000Z"),
        seq: read_seed_time("2026-06-01T08:30:01.000Z"),
        actor: andreasSeller,
        changes: [["Brand", "TYMELY Social", "TYMELY Growth Studio"]]
    },
    {
        id: "brand-archived",
        type: "BRAND_ARCHIVED",
        app: "niffler",
        at: read_seed_time("2026-06-10T10:00:00.000Z"),
        seq: read_seed_time("2026-06-10T10:00:01.000Z"),
        actor: andreasSeller,
        changes: [["Archived", "No", "Yes"]]
    },
    {
        id: "brand-restored",
        type: "BRAND_ARCHIVED",
        app: "niffler",
        at: read_seed_time("2026-06-12T11:00:00.000Z"),
        seq: read_seed_time("2026-06-12T11:00:01.000Z"),
        actor: mariaSeller,
        text: "The Brand was restored after the owner confirmed that operations had resumed.",
        changes: [["Archived", "Yes", "No"]]
    },
    {
        id: "legacy-event",
        type: "LEGACY_EVENT",
        app: "niffler",
        at: read_seed_time("2026-06-15T10:00:00.000Z"),
        seq: read_seed_time("2026-06-15T10:00:01.000Z"),
        actor: {
            id: "legacy-import",
            label: "Legacy import"
        },
        text: "Historical account note imported from the previous Leads timeline."
    },
    {
        id: "generic-actorless-event",
        type: "GENERIC",
        app: "niffler",
        at: read_seed_time("2026-06-20T10:00:00.000Z"),
        seq: read_seed_time("2026-06-20T10:00:01.000Z"),
        text: "A retained source event does not yet have a dedicated renderer."
    }
];
